import React from 'react';
import { ServicesHero } from '../components/inner/ServicesHero';
import { HomeServices } from '../components/home/HomeServices';
import { HomeLocations } from '../components/home/HomeLocations';
import '../styles/reference-home.css';
import '../styles/inner-pages.css';

export default function Services() {
  return (
    <div className="reference-home inner-page services-page" data-testid="services-page">
      <ServicesHero />
      <HomeServices />
      <HomeLocations />
    </div>
  );
}